import ApiConstant from "../../constants/api.constants";
import Helpers from "../../utils/helpers";
import api from "../api";
import TokenService from "../autentication/token.service";
const baseURL = process.env.REACT_APP_SERVER_ENDPOINT; 

const getCurrentUser = async () => {
  return await api.post(`${baseURL}${ApiConstant.getUser}`).then((response: any) => {
    Helpers.ConsoleLog(response);
    TokenService.setUser(response?.data);
    return response.data;
  });;
};
const getUserSettings = async () => {
  return await api.get(`${baseURL}${ApiConstant.getUserSettings}`).then((response: any) => {
    Helpers.ConsoleLog(response);
    return response.data;
  });;
};

const UserService = {
  getCurrentUser,
  getUserSettings
};

export default UserService;